import { merge, } from "rxjs";
import { publish, skip, take } from "rxjs/operators";
export function initial(countOrOperator, operator) {
    let count;
    if (typeof countOrOperator === "number") {
        count = countOrOperator;
    }
    else {
        count = 1;
        operator = countOrOperator;
    }
    return (source) => source.pipe(publish((published) => merge(published.pipe(take(count), operator), published.pipe(skip(count)))));
}
//# sourceMappingURL=initial.js.map